var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormattedMessage, injectIntl } from "react-intl";
import { ApplicationContext } from "../../../../ApplicationContext";
import React from "react";
import DeviceBatteryStatus from "../DeviceBatteryStatus/DeviceBatteryStatus";
import DateTime from "../DateTime/DateTime";
import ActivityStatus from "../../../../data/ActivityStatus";
import Signals from "../../../../signals/Signals";
import GetDeviceSettingsCommand from "../../../../commands/devices/GetDeviceSettingsCommand";
import UpdateDeviceSettingsOverlay from "../../../pages/Devices/UpdateDeviceSettingsOverlay";
import DetachDeviceCommand from "../../../../commands/devices/DetachDeviceCommand";
import GetOrganisationAssetsCommand from "../../../../commands/assets/GetOrganisationAssetsCommand";
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
var DeviceDetailWidget = /** @class */ (function (_super) {
    __extends(DeviceDetailWidget, _super);
    /**
     *
     * @param props
     */
    function DeviceDetailWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { showLastConnected: false };
        _this.loadDeviceSettings = _this.loadDeviceSettings.bind(_this);
        _this.detachDevice = _this.detachDevice.bind(_this);
        _this.deviceDetached = _this.deviceDetached.bind(_this);
        return _this;
    }
    /**
     *
     * @return {*}
     */
    DeviceDetailWidget.prototype.render = function () {
        var _this = this;
        var device = this.props.device;
        var showLastConnected = this.state.showLastConnected;
        var iconClassName = "";
        var locationTimeClasses = "";
        switch (device.activityStatus) {
            case ActivityStatus.EXPIRED:
                iconClassName = " fe-alert-circle text-warning";
                locationTimeClasses = 'fe fe-alert-circle text-warning mr-2';
                break;
            case ActivityStatus.NONE:
                iconClassName = " fe-x-circle text-danger";
                locationTimeClasses = 'fe fe-x-circle text-danger mr-2';
                break;
            case ActivityStatus.RECENT:
                iconClassName = " fe-check-circle text-success";
                locationTimeClasses = 'fe fe-clock mr-2';
                break;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("tr", null,
                React.createElement("td", { colSpan: 3 },
                    React.createElement("hr", null))),
            React.createElement("tr", null,
                React.createElement("td", { className: "font-weight-bold text-nowrap  align-text-top pr-3" },
                    React.createElement(FormattedMessage, { id: "asset.detail.sensor.label" })),
                React.createElement("td", { colSpan: 2 },
                    React.createElement("div", { className: "d-flex justify-content-start" },
                        React.createElement("div", null, device.name || device.link_device_id_serial),
                        React.createElement("div", { className: "position-relative flex-grow-1" },
                            React.createElement("span", { onMouseEnter: function () { return _this.setState({ showLastConnected: true }); }, onMouseLeave: function () { return _this.setState({ showLastConnected: false }); }, className: "fe ml-3" + iconClassName }),
                            showLastConnected &&
                                React.createElement("div", { className: "p-3 position-absolute box-shadow bg-white" },
                                    React.createElement("div", { className: "font-weight-bold text-nowrap align-text-top pr-3" },
                                        React.createElement(FormattedMessage, { id: "device.detail.field.serialnumber" }),
                                        "\u00A0",
                                        device.link_device_id_serial),
                                    React.createElement("div", { className: "font-weight-bold text-nowrap  align-text-top pr-3" },
                                        React.createElement(FormattedMessage, { id: "asset.detail.lastseen.label" })),
                                    React.createElement(DateTime, { date: device.lastConnectedDateTime, timeClasses: locationTimeClasses }))),
                        React.createElement("button", { className: 'btn btn-sm', onClick: this.loadDeviceSettings },
                            React.createElement("i", { className: "fe fe-settings" })),
                        React.createElement("button", { className: 'btn btn-sm ml-0', onClick: this.detachDevice },
                            React.createElement("i", { className: "fe fe-trash" }))))),
            React.createElement("tr", null,
                React.createElement("td", { className: "font-weight-bold text-nowrap  align-text-top pr-3" },
                    React.createElement(FormattedMessage, { id: "asset.detail.batterystatus.label" })),
                React.createElement("td", null,
                    React.createElement(DeviceBatteryStatus, { device: device }),
                    device.batteryRemainingPctDateTime &&
                        React.createElement("span", { className: "small text-muted d-block" },
                            React.createElement(DateTime, { date: device.batteryRemainingPctDateTime }))))));
    };
    DeviceDetailWidget.prototype.loadDeviceSettings = function () {
        var _this = this;
        var session = this.context.session;
        var _a = this.props, device = _a.device, intl = _a.intl;
        var command = new GetDeviceSettingsCommand();
        command.execute(device.link_device_id, session.user.organisation.id)
            .then(function (r) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            Signals.ShowOverlay.dispatch(React.createElement(UpdateDeviceSettingsOverlay, { deviceModel: device, initialOperatingHoursEnabled: (_d = (_b = (_a = r.operatingHoursEnabled.desired) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : (_c = r.operatingHoursEnabled.reported) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : true, initialGpsSettingValue: (_h = (_f = (_e = r.gps.desired) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : (_g = r.gps.reported) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : 'Medium', initialWakeupIntervalSecondsValue: (_m = (_k = (_j = r.wakeupIntervalSeconds.desired) === null || _j === void 0 ? void 0 : _j.value) !== null && _k !== void 0 ? _k : (_l = r.wakeupIntervalSeconds.reported) === null || _l === void 0 ? void 0 : _l.value) !== null && _m !== void 0 ? _m : 3600 * 12, onDeviceUpdate: function () { return _this.forceUpdate(); } }));
        }).catch(function (r) {
            Signals.ShowNotification.dispatch(intl.formatMessage({ id: "device.settings.error" }, device), 'danger', true);
        });
        ;
    };
    DeviceDetailWidget.prototype.detachDevice = function () {
        var _this = this;
        var _a = this.context, session = _a.session, deviceCollection = _a.deviceCollection;
        var _b = this.props, intl = _b.intl, device = _b.device;
        Signals.ShowConfirmModal.dispatch(intl.formatMessage({ id: 'page.devices.detach.confirm.title' }), intl.formatMessage({ id: 'page.devices.detach.confirm.body' }, device), intl.formatMessage({ id: 'page.devices.detach.confirm.yes' }), intl.formatMessage({ id: 'page.devices.detach.confirm.no' }), function () {
            var command = new DetachDeviceCommand();
            command.execute(session.user.organisation.id, device, intl).then(_this.deviceDetached);
        });
    };
    DeviceDetailWidget.prototype.deviceDetached = function () {
        // Refresh assets
        var _a = this.context, session = _a.session, assetCollection = _a.assetCollection;
        var user = session.user;
        var _b = this.props, onDeviceDetached = _b.onDeviceDetached, device = _b.device, intl = _b.intl;
        device.attachedToAsset = null;
        var command = new GetOrganisationAssetsCommand();
        // Do show feedback to the user that getting the assets failed, so the user knows the overview is not the latest overview
        command.execute(user.organisation, assetCollection).then(function () {
            if (onDeviceDetached) {
                onDeviceDetached();
            }
        }).catch(function () {
            Signals.ShowNotification.dispatch(intl.formatMessage({ id: "error.assets.getcommand" }), 'danger', true);
        });
    };
    DeviceDetailWidget.defaultProps = {
        className: ''
    };
    return DeviceDetailWidget;
}(React.Component));
DeviceDetailWidget.contextType = ApplicationContext;
export default injectIntl(DeviceDetailWidget);
